import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Divider,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { baseURL } from "../services/api";
import { SubjectCodes } from "../utils";

function StudentDetails() {
  const location = useLocation();
  const preDetails = location.state?.details;
  const [stateDetails, setStateDetails] = useState({});

  const schoolId = location.state?.schoolId;
  const schoolName = location.state?.schoolName;
  console.log(stateDetails, "stateDetails");
  const navigate = useNavigate();
  useEffect(() => {
    // if (!preDetails || !preDetails.compartmentFormRequest_data) return;
    console.log("preDetails change:", preDetails);

    const cleanedStateDetails = Object.fromEntries(
      Object.entries(preDetails).map(([key, value]) => [
        key,
        value === "NaN" ? "" : value,
      ])
    );
    const realDetails = {
      ...cleanedStateDetails,
      ...cleanedStateDetails?.compartmentFormRequest_data?.other_data,
    };

    setStateDetails(realDetails);
  }, [preDetails]);

  const handlePrint = () => {
    const originalContents = document.body.innerHTML;

    const printContents = document.getElementById("print-section").innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); // Optional: reload to reset UI
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      position="absolute"
      top="50%"
      left="50%"
      width={"80%"}
      height={"85%"} // Set height to 90%
      overflow="auto"
      p={4}
      bgcolor="background.paper"
      boxShadow={24}
      borderRadius={2}
      style={{ transform: "translate(-50%, -50%)" }}
    >
      <Box sx={{ flexGrow: 1, p: 2 }} id="print-section">
        <Grid container spacing={2}>
          {/* Full width Card */}
          <Grid item xs={12}>
            <Card sx={{ border: "2px solid #122e5b" }}>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#122e5b",
                  color: "white",
                  padding: "10px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                PERSONAL DETAILS:- [ "Applied" ]
                <span
                  style={{
                    marginLeft: "17px",
                    width: "15px",
                  }}
                >
                  {stateDetails?.applycat === "C"
                    ? "Compartment"
                    : stateDetails?.applycat === "B"
                    ? "Betterment"
                    : "Special"}

                  {/* {stateDetails?.fr === "F" ? "Compartment" : "Special"} */}
                </span>
              </Typography>
              <Divider />

              {/* Card Content with 4 Box Grid Layout */}
              <CardContent>
                <Grid container spacing={2}>
                  {/* Box 1 */}
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>School Code/Name:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography
                          style={{ color: "green", fontWeight: "bold" }}
                        >
                          {schoolId}/{schoolName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>Registration No:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          {stateDetails?.o_reg ? stateDetails?.o_reg : "_"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>BSEB Unique ID:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          {" "}
                          {stateDetails?.uniqid ? stateDetails?.uniqid : "_"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>Transaction ID:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          {" "}
                          {stateDetails?.compartmentFormRequest_data
                            ?.transaction_id
                            ? stateDetails?.compartmentFormRequest_data
                                ?.transaction_id
                            : "_"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>Mother's Name:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          {" "}
                          {stateDetails?.mnm ? stateDetails?.mnm : "_"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>Student's Name:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography style={{ fontWeight: "bold" }}>
                          {stateDetails?.nm ? stateDetails?.nm : "_"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>Date of Birth:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          {stateDetails?.dob ? stateDetails?.dob : "_"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>Father's Name:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          {" "}
                          {stateDetails?.fnm ? stateDetails?.fnm : "_"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>Caste Category:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          {stateDetails?.caste ? stateDetails?.caste : "_"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          <b>sex:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6 }}>
                        <Typography>
                          {" "}
                          {stateDetails?.sex ? stateDetails?.sex : "_"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography>
                          <b>Mobile No.:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <TextField
                          disabled
                          fullWidth
                          size="small"
                          value={
                            stateDetails?.mobile ? stateDetails?.mobile : "_"
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
                          Differently abled:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <TextField
                          disabled
                          fullWidth
                          size="small"
                          value={stateDetails?.ph ? stateDetails?.ph : "_"}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    size={{ xs: 12, md: 6 }}
                    style={{ paddingBottom: "12px" }}
                  >
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography>
                          <b>Email Address:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <TextField
                          disabled
                          fullWidth
                          size="small"
                          value={
                            stateDetails?.email ? stateDetails?.email : "_"
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    size={{ xs: 12, md: 6 }}
                    style={{ paddingBottom: "12px" }}
                  >
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography>
                          <b> Visually impaired:</b>
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <TextField
                          disabled
                          fullWidth
                          size="small"
                          value={
                            stateDetails?.VisuallyImpared
                              ? stateDetails?.VisuallyImpared
                              : "_"
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    borderTop: "2px solid #ccc",
                    borderBottom: "2px solid #ccc",
                    paddingTop: 2,
                    paddingBottom: 2,
                  }}
                >
                  <Grid container spacing={2} alignItems="flex-start">
                    {/* Left Side Text */}

                    {/* Right Side Input Field */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                      <TextField
                        disabled
                        label="Aadhar Number"
                        placeholder="e.g., 9999-9999-9999"
                        variant="outlined"
                        fullWidth
                        sx={{ marginBottom: 1 }}
                        value={
                          // stateDetails?.adh11
                          //   ? stateDetails?.adh11
                          //   : aadharCard

                          stateDetails?.adh11 == "00"
                            ? "_"
                            : stateDetails?.adh11
                            ? stateDetails?.adh11
                            : "_"
                        }
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          color: "gray",
                          textAlign: "right",
                        }}
                      >
                        e.g., 9999-9999-9999
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  sx={{
                    borderTop: "2px solid #ccc",
                    paddingTop: 2,
                    margin: "20px auto",
                  }}
                >
                  {/* First Row */}
                  <Grid container spacing={2}>
                    {/* Column 1: Labels */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography variant="body2" fontWeight="bold">
                            Area:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.region
                                ? stateDetails?.region
                                : stateDetails?.compartmentFormRequest_data
                                    ?.other_data?.region
                                ? stateDetails?.compartmentFormRequest_data
                                    ?.other_data?.region
                                : "_"
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography variant="body2" fontWeight="bold">
                            Nationality:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.national
                                ? stateDetails?.national == "I"
                                  ? "Indian"
                                  : stateDetails?.national
                                : "Indian"
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography variant="body2" fontWeight="bold">
                            Religion:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.religion
                                ? stateDetails?.religion == "H"
                                  ? "Hindhu"
                                  : stateDetails?.religion == "C"
                                  ? "Christian"
                                  : stateDetails?.religion == "B"
                                  ? "Buddhism"
                                  : stateDetails?.religion == "J"
                                  ? "Jainism"
                                  : stateDetails?.religion == "S"
                                  ? "Sikhism"
                                  : stateDetails?.religion == "I"
                                  ? "Islam"
                                  : "Other"
                                : "Other"
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography variant="body2" fontWeight="bold">
                            Marital Status:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.merit ? stateDetails?.merit : "_"
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            sx={{ mb: 3 }}
                          >
                            Medium of Exam:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.md
                                ? stateDetails?.md === "H"
                                  ? "Hindi"
                                  : "English"
                                : stateDetails?.compartmentFormRequest_data?.md
                                ? stateDetails?.compartmentFormRequest_data
                                    ?.md === "H"
                                  ? "Hindi"
                                  : "English"
                                : "_"
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography variant="body2" fontWeight="bold">
                            Student Category:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.applycat === "C"
                                ? "Compartment"
                                : stateDetails?.applycat === "E"
                                ? "Ex-Student"
                                : stateDetails?.applycat === "B"
                                ? "Betterment"
                                : stateDetails?.applycat === "R"
                                ? "Reg/Pvt"
                                : stateDetails?.applycat ===
                                  "Single Subject (English)"
                                ? "Single Subject (English)"
                                : stateDetails?.applycat === "Opt. Prac"
                                ? "Opt. Prac"
                                : "Others"
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    {(stateDetails?.applycat === "C" ||
                      stateDetails?.applycat === "E" ||
                      stateDetails?.applycat === "B" ||
                      stateDetails?.applycat ===
                        "Single Subject (English)") && (
                      <>
                        <Grid item size={{ xs: 12, md: 6 }}>
                          <Grid container spacing={1}>
                            <Grid item size={{ sm: 6, xs: 12 }}>
                              <Typography variant="body2" fontWeight="bold">
                                Roll Code:
                              </Typography>
                            </Grid>
                            <Grid item size={{ sm: 6, xs: 12 }}>
                              <TextField
                                disabled
                                size="small"
                                fullWidth
                                value={
                                  stateDetails?.ex_rollcd
                                    ? stateDetails?.ex_rollcd
                                    : "_"
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                          <Grid container spacing={1}>
                            <Grid item size={{ sm: 6, xs: 12 }}>
                              <Typography variant="body2" fontWeight="bold">
                                Roll No:
                              </Typography>
                            </Grid>
                            <Grid item size={{ sm: 6, xs: 12 }}>
                              <TextField
                                disabled
                                size="small"
                                fullWidth
                                value={
                                  stateDetails?.ex_rollno
                                    ? stateDetails?.ex_rollno
                                    : "_"
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                          <Grid container spacing={1}>
                            <Grid item size={{ sm: 6, xs: 12 }}>
                              <Typography variant="body2" fontWeight="bold">
                                Previour Exam Year:
                              </Typography>
                            </Grid>
                            <Grid item size={{ sm: 6, xs: 12 }}>
                              <TextField
                                disabled
                                size="small"
                                fullWidth
                                value={
                                  stateDetails?.ex_yr_exam
                                    ? stateDetails?.ex_yr_exam
                                    : "_"
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                  <Box sx={{ pt: 2, borderTop: "2px solid #ccc", mt: 2 }}>
                    <Typography fontSize="16px" fontWeight="bold" gutterBottom>
                      SUBJECT OFFERED:
                    </Typography>
                    <br />
                    <Grid
                      container
                      spacing={2}
                      style={{
                        flex: 1,
                        // backgroundColor: "red",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* MIL */}
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography align="center" fontWeight="bold">
                          MIL
                        </Typography>
                        <br />

                        {/* <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue={
                              stateDetails?.sub1 === "MHND"
                                ? "Hindi"
                                : stateDetails?.sub1 === "MURD"
                                ? "URDU"
                                : stateDetails?.sub1 === "MMAI"
                                ? "Maithli"
                                : stateDetails?.sub1 === "MBNG"
                                ? "Bangla"
                                : "Other"
                            }
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          /> */}

                        <Box
                          key={
                            stateDetails?.sub1 === "MHND"
                              ? "Hindi"
                              : stateDetails?.sub1 === "MURD"
                              ? "URDU"
                              : stateDetails?.sub1 === "MMAI"
                              ? "Maithli"
                              : stateDetails?.sub1 === "MBNG"
                              ? "Bangla"
                              : "Other"
                          }
                          display="flex"
                          alignItems="center"
                          width="90%"
                          mb={0.5}
                        >
                          <Checkbox
                            checked={stateDetails?.compartmentFormRequest_data?.other_data?.selectedSubjects?.includes(
                              "sub1"
                            )}
                            disabled
                            // onChange={() => {
                            //   handleSelectedSubjects("sub1");
                            // }}
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled
                            value={
                              stateDetails?.sub1 === "MHND"
                                ? "Hindi"
                                : stateDetails?.sub1 === "MURD"
                                ? "URDU"
                                : stateDetails?.sub1 === "MMAI"
                                ? "Maithli"
                                : stateDetails?.sub1 === "MBNG"
                                ? "Bangla"
                                : "Other"
                            }
                          />
                        </Box>
                        {/* <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="URD-URDU"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="Bangla"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="Maithli"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          /> */}
                      </Grid>

                      {/* SIL */}
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography align="center" fontWeight="bold">
                          SIL
                        </Typography>
                        <br />
                        {/* <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue={
                              stateDetails?.sub2 === "SSNK"
                                ? "Sankrit"
                                : stateDetails?.sub2 === "SBHO"
                                ? "Bhojpuri"
                                : stateDetails?.sub2 === "SNLH"
                                ? "Hindi"
                                : stateDetails?.sub2 === "SARB"
                                ? "Arabic"
                                : "Persian"
                            }
                            disabled
                            style={{
                              marginBottom: "5px",
                            }}
                          /> */}
                        <Box
                          key={
                            stateDetails?.sub2 === "SSNK"
                              ? "Sankrit"
                              : stateDetails?.sub2 === "SBHO"
                              ? "Bhojpuri"
                              : stateDetails?.sub2 === "SNLH"
                              ? "Hindi"
                              : stateDetails?.sub2 === "SARB"
                              ? "Arabic"
                              : "Persian"
                          }
                          display="flex"
                          alignItems="center"
                          width="90%"
                          mb={0.5}
                        >
                          <Checkbox
                            // checked={selectedSubjects?.includes("sub2")}
                            checked={stateDetails?.compartmentFormRequest_data?.other_data?.selectedSubjects?.includes(
                              "sub2"
                            )}
                            disabled
                            // onChange={() => {
                            //   handleSelectedSubjects("sub2");
                            // }}
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled
                            value={
                              stateDetails?.sub2 === "SSNK"
                                ? "Sankrit"
                                : stateDetails?.sub2 === "SBHO"
                                ? "Bhojpuri"
                                : stateDetails?.sub2 === "SNLH"
                                ? "Hindi"
                                : stateDetails?.sub2 === "SARB"
                                ? "Arabic"
                                : "Persian"
                            }
                          />
                        </Box>
                        {/* <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="Hindi"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="Arabic"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="Persian"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="Bhojpuri"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          /> */}
                      </Grid>

                      {/* COMPULSORY SUBJECTS */}
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 3,
                          // borderTop: "2px solid #ccc",
                          // mt: 2,
                        }}
                      >
                        <Typography align="center" fontWeight="bold">
                          COMPULSORY SUBJECTS
                        </Typography>
                        <br />
                        {[
                          {
                            label: stateDetails.sub3,
                            names: "sub3",
                            disabled: true,
                          },
                          {
                            label: stateDetails.sub4,
                            names: "sub4",
                            disabled: false,
                          },
                          {
                            label: stateDetails.sub5,
                            names: "sub5",
                            disabled: false,
                          },
                          {
                            label: stateDetails.sub7,
                            names: "sub7",
                            disabled: false,
                          },
                        ].map(({ label, names, disabled }) => (
                          <Box
                            key={SubjectCodes?.[label]}
                            display="flex"
                            alignItems="center"
                            width="90%"
                            mb={0.5}
                          >
                            <Checkbox
                              checked={stateDetails?.compartmentFormRequest_data?.other_data?.selectedSubjects?.includes(
                                names
                              )}
                              // checked={selectedSubjects?.includes(names)}
                              disabled
                            />
                            <TextField
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={SubjectCodes?.[label]}
                              disabled
                            />
                          </Box>
                          // <TextField
                          //   variant="outlined"
                          //   size="small"
                          //   fullWidth
                          //   defaultValue={SubjectCodes?.[label]}
                          //   disabled
                          //   style={{
                          //     marginBottom: "5px",
                          //   }}
                          // />
                        ))}

                        {/* <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="SCI-SCIENCE"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          />

                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="SSC-SOCIAL SCIENCE"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue="English"
                            style={{
                              marginBottom: "5px",
                            }}
                            disabled
                          /> */}
                      </Grid>

                      {/* OPTIONAL SUBJECT */}
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography align="center" fontWeight="bold">
                          OPTIONAL SUBJECT
                        </Typography>
                        <br />
                        <Box
                          key={stateDetails?.sub6}
                          display="flex"
                          alignItems="center"
                          width="90%"
                          mb={0.5}
                        >
                          <Checkbox
                            // checked={selectedSubjects?.includes("sub6")}
                            disabled
                            checked={stateDetails?.compartmentFormRequest_data?.other_data?.selectedSubjects?.includes(
                              "sub6"
                            )}
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.sub6 ? stateDetails?.sub6 : "NA"
                            }
                            disabled
                          />
                        </Box>
                        <Box
                          style={{
                            marginTop: "50px",
                          }}
                        >
                          <Typography align="center" fontWeight="bold">
                            VOCATIONAL SUBJECT
                          </Typography>
                          <br />
                          {/* <TextField
                              variant="outlined"
                              size="small"
                              fullWidth
                              defaultValue={
                                stateDetails?.sb8 ? stateDetails?.sb8 : "NA"
                              }
                              disabled
                            /> */}
                          <Box
                            key={stateDetails?.sub8}
                            display="flex"
                            alignItems="center"
                            width="90%"
                            mb={0.5}
                          >
                            <Checkbox
                              // checked={selectedSubjects?.includes("sub8")}
                              disabled
                              checked={stateDetails?.compartmentFormRequest_data?.other_data?.selectedSubjects?.includes(
                                "sub8"
                              )}
                            />
                            <TextField
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={
                                stateDetails?.sub8 ? stateDetails?.sub8 : "NA"
                              }
                              disabled
                            />
                          </Box>
                        </Box>
                      </Grid>
                      {/* <Grid item size={{ xs: 12, md: 2 }}>
                         
                        </Grid> */}
                    </Grid>
                  </Box>

                  {/* Address Details */}
                  <Divider sx={{ my: 3, borderTop: "2px solid #ccc", mt: 3 }} />
                  <Typography
                    fontSize="16px"
                    marginBottom="16px"
                    fontWeight="bold"
                    gutterBottom
                  >
                    ADDRESS DETAILS:
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography variant="body2" fontWeight="bold">
                            Address:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.adderss
                                ? stateDetails?.adderss
                                : "_"
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography variant="body2" fontWeight="bold">
                            District Name:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={stateDetails?.dst ? stateDetails?.dst : "_"}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography variant="body2" fontWeight="bold">
                            Town / City Name:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.town ? stateDetails?.town : "_"
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Grid container spacing={1}>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <Typography variant="body2" fontWeight="bold">
                            Pincode:
                          </Typography>
                        </Grid>
                        <Grid item size={{ sm: 6, xs: 12 }}>
                          <TextField
                            disabled
                            size="small"
                            fullWidth
                            value={
                              stateDetails?.pcrtno ? stateDetails?.pcrtno : "_"
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ pt: 2, borderTop: "2px solid #ccc", mt: 2 }}>
                  <Typography fontWeight="bold" gutterBottom>
                    PHOTO & SIGNATURE:
                  </Typography>
                  <Grid container spacing={2}>
                    {/* Photo Section */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Box
                        sx={{
                          padding: "8px",
                        }}
                      >
                        {stateDetails?.compartmentFormRequest_data
                          ?.photograph_path ? (
                          <img
                            src={`${baseURL}${
                              stateDetails?.compartmentFormRequest_data?.photograph_path?.startsWith(
                                "/"
                              )
                                ? stateDetails?.compartmentFormRequest_data?.photograph_path?.slice(
                                    1
                                  )
                                : stateDetails?.compartmentFormRequest_data
                                    ?.photograph_path
                            }`}
                            alt="Uploaded Photo"
                            style={{
                              width: "100px",
                              height: "50px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        ) : (
                          <Typography
                            sx={{
                              color: "#999",
                              fontSize: "14px",
                              fontStyle: "italic",
                            }}
                          >
                            No photo uploaded
                          </Typography>
                        )}
                      </Box>
                    </Grid>

                    {/* Signature Section */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Box
                        sx={{
                          padding: "8px",
                        }}
                      >
                        {stateDetails?.compartmentFormRequest_data
                          ?.signature_path ? (
                          <img
                            src={`${baseURL}${stateDetails?.compartmentFormRequest_data?.signature_path}`}
                            alt="Uploaded Signature"
                            style={{
                              width: "100px",
                              height: "50px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        ) : (
                          <Typography
                            sx={{
                              color: "#999",
                              fontSize: "14px",
                              fontStyle: "italic",
                            }}
                          >
                            No signature uploaded
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  sx={{
                    pt: 2,
                    textAlign: "center",
                    borderTop: "2px solid #ccc",
                    mt: 2,
                  }}
                >
                  {/* Apply Button */}
                  <Box sx={{ mt: 2 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (schoolId) {
                          navigate(`/school-details/${schoolId}`);
                        } else {
                          navigate(`/edit-user`);
                        }
                      }}
                      sx={{
                        px: 4,
                      }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handlePrint}
                      sx={{
                        marginLeft: 4,
                      }}
                    >
                      Print
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default StudentDetails;
